import { ConfigOption } from '@ngx-formly/core';
import { FormlyFieldSelect } from './select.type';

export function withFormlySelect(): ConfigOption {
  return {
    types: [
      {
        name: 'select',
        component: FormlyFieldSelect,
        wrappers: ['form-field']
      }
    ]
  };
}